import { WORKSPACE_FRAME_PADDING } from '@components/v2/constants';
import { BOTTOMBAR } from '@components/v2/layout/AppTemplate/appTemplate.consts';
import { makeStyles } from 'tss-react/mui';

export const useBottomBarStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    height: BOTTOMBAR.height,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(
      WORKSPACE_FRAME_PADDING,
      WORKSPACE_FRAME_PADDING,
      WORKSPACE_FRAME_PADDING,
      1,
    ),
    background: theme.palette.background.default,
    flexShrink: 0,
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));
